import { render, staticRenderFns } from "./UploadWrapper.vue?vue&type=template&id=6bc5fdee&scoped=true&"
import script from "./UploadWrapper.vue?vue&type=script&lang=js&"
export * from "./UploadWrapper.vue?vue&type=script&lang=js&"
import style0 from "./UploadWrapper.vue?vue&type=style&index=0&id=6bc5fdee&lang=stylus&scoped=true&"
import style1 from "./UploadWrapper.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc5fdee",
  null
  
)

export default component.exports